import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRouter from './components/appRouter/AppRouter'
import "./styles/css/App.css"
import "./styles/css/pop-up-window.css"
import "@fontsource/roboto"
import Colors from "./values/Colors";
import QrScanner from "./components/UI/qrCode/qrScanner/QrScanner";
import env from '../package.json'
import { setSidebarStatus } from "redux/slice/sidebarSlice";
import { useDeviceType } from "components/hooks/useDeviceType";
import { RefMainContainerContext } from 'context';
import Footer from "components/UI/footer/Footer";
import OAuthService from "services/OAuthService";
import Notifications from "components/UI/popupNotifications/Notifications";
import { useFetching } from "components/hooks/useFetching";
import CommandService from "services/CommandService";
import "./styles/scss/variables.css"
import "./styles/values.css"
import Strings from "values/Strings";

function App() {
    // const title = useSelector(state => state.title.text)
    const addressBarName1 = window.location.pathname.slice(1).split('/')[0]
    const addressBarName2 = window.location.pathname.slice(1).split('/')[1]
    const onScrollBar = useSelector(state => state.scrollBar.status)
    const cameraStatus = useSelector(state => state.camera.isCamera)
    const sidebarStatus = useSelector(state => state.sidebar.isActive)
    // const loader = useSelector(state => state.loader.status)
    const sidebarItemName = useSelector(state => state.sidebarItem.item)
    const popUpWindowStatus = useSelector(state => state.popUpWindow.status)

    // const userNavbarList = [Strings.sidebarGrade, Strings.sidebarProfile, Strings.sidebarMain]
    const adminNavbarList = [Strings.sidebarAdminPanel]
    const navbarNameList = ['admin', 'profile', 'team-grade-page']
    const mainNavbarList = ['main', 'logout']
    const device = useDeviceType()
    const dispatch = useDispatch()
    const mainContainerRef = useRef(null)

    function closeSideBar() {
        device === 'phone' && dispatch(setSidebarStatus(false))
    }


    useEffect(() => {
        dispatch(setSidebarStatus(device === 'desktop'))
    }, [])




    return (
        <RefMainContainerContext.Provider value={{ mainContainerRef }}>
            <BrowserRouter>
                {cameraStatus === true ?
                    <QrScanner />
                    :
                    <div className="wrapper" style={{ overflow: popUpWindowStatus ? 'hidden' : '' }}>
                        <div className='content' style={{
                            paddingTop: (adminNavbarList.includes(sidebarItemName) || navbarNameList.includes(addressBarName1) || navbarNameList.includes(addressBarName2) || mainNavbarList.includes(addressBarName1)) ? (device === 'phone' ? '5vh' : "10vh") : "0",
                            // marginLeft: sidebarStatus ? env.sidebar.width : "0",
                            marginLeft: device === 'desktop' ? (((env.sidebar.minWidth - 2) + 'vw')) : '0',
                        }}>
                            <div className="content__container" ref={mainContainerRef} onClick={closeSideBar}>
                                <AppRouter />
                            </div>
                        </div>
                        {(addressBarName2 ? !addressBarName2.includes('team-grade-page') : true) &&
                            <div className={`${'footer-container'} ${popUpWindowStatus && 'pop-up-blure'}`} style={{
                                marginLeft: device === 'desktop' ? (sidebarStatus ? env.sidebar.width - 2 + 'vw' : env.sidebar.minWidth - 2 + 'vw') : '0',
                                width: device === 'desktop' ? (sidebarStatus ? `calc(100% - ${env.sidebar.width - 2}vw)` : `calc(100% - ${env.sidebar.minWidth - 2}vw)`) : '100%'
                            }}>
                            </div>
                        }
                    </div>
                }
                <Notifications />
            </BrowserRouter >
        </RefMainContainerContext.Provider>
    );
}

export default App;